import type { ParseParams } from 'zod';
import { z } from 'zod';

export const getI18nErrorMap = (
  translateFn: (error: string) => string,
): ParseParams['errorMap'] => {
  return (error, ctx) => {
    const fieldName = error.path[error.path.length - 1];

    let errorKey = '';

    switch (error.code) {
      case z.ZodIssueCode.invalid_type:
      case z.ZodIssueCode.too_small:
        errorKey = `${fieldName}Required`;
        break;

      case z.ZodIssueCode.invalid_string:
        if (error.validation === 'email') {
          errorKey = `${fieldName}Invalid`;
        }

        break;

      case z.ZodIssueCode.too_big:
        errorKey = 'tooLong';
        break;

      case z.ZodIssueCode.custom:
        if (error.message) {
          errorKey = error.message;
        }

        break;

      case z.ZodIssueCode.invalid_enum_value:
      case z.ZodIssueCode.unrecognized_keys:
      case z.ZodIssueCode.invalid_literal:
      case z.ZodIssueCode.invalid_arguments:
      case z.ZodIssueCode.invalid_return_type:
      case z.ZodIssueCode.invalid_union:
      case z.ZodIssueCode.invalid_union_discriminator:
      case z.ZodIssueCode.invalid_date:
      case z.ZodIssueCode.invalid_intersection_types:
      case z.ZodIssueCode.not_multiple_of:
      case z.ZodIssueCode.not_finite:
      default:
        break;
    }

    if (!errorKey.length || !translateFn(errorKey)) {
      return { message: ctx.defaultError };
    }

    return { message: translateFn(errorKey) };
  };
};
